import { Injectable, inject } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { RestService } from '../../../services/rest/rest.service';
import { AssumptionsData, InvestmentGoal } from '../../../domain/lti/lti.domain';
import { GoalType } from '../../../domain/lti/lti.enum';

/**
 * This Service is for saving assumptions and for resetting assumptions
 */
@Injectable({
  providedIn: 'root'
})
export class GoalAssumptionsService {
  private readonly restService = inject(RestService);

  readonly onAssumptionsChange: Subject<AssumptionsData>;
  private goalType: GoalType = GoalType.RETIREMENT;
  private defaultGoalAssumptions: InvestmentGoal;

  constructor() {
    this.onAssumptionsChange = new Subject<AssumptionsData>();
  }

  //  This function is used by assumptions to set and pass the assumptions data
  setAssumptions(assumptions: AssumptionsData): void {
    if (assumptions !== undefined) {
      this.onAssumptionsChange.next(assumptions);
    }
  }

  retrieveDefaultAssumptions(goalType: GoalType): Observable<InvestmentGoal> {
    if (this.defaultGoalAssumptions !== undefined && goalType === this.goalType) {
      return of(this.defaultGoalAssumptions);
    }
    return this.restService.getResource('wealthInvestment.getDefaultValues').get({ params: { type: goalType } }).pipe(
      map((defaultGoalAssumptions: InvestmentGoal): InvestmentGoal => {
        this.defaultGoalAssumptions = defaultGoalAssumptions;
        this.goalType = goalType;
        return defaultGoalAssumptions;
      })
    );
  }
}

